import { ApiClient } from "./api-client";

export function getAcls() {
  return ApiClient.getInstance().get('/acl').catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}